import React, { createContext, useContext, useMemo, useState } from "react";

const UIContext = createContext();

export const UIProvider = ({ children }) => {
  const [isCollapsed, setIsCollapsed] = useState(true);

  const value = useMemo(
    () => ({ isCollapsed, setIsCollapsed }),
    [isCollapsed]
  );

  return <UIContext.Provider value={value}>{children}</UIContext.Provider>;
};

export const useUI = () => useContext(UIContext);
